/**
 * This component renders a container for pages
 * @param {object} children - Children elements inside the container
 */
import React from "react";

const Container = ({ children }) => {
  return (
    // Container for all pages
    <div className="container min-h-[60vh] mx-auto bg-light-1 dark:bg-dark-1">
      {children}
    </div>
  );
}
export default Container;